export default (function (value) {
  /**
   * isObject({}) => true
   * isObject([1, 2, 3]) => true
   * isObject(Function) => true
   * isObject(null) => false
   */
  var type = typeof value;
  return value !== null && type === 'object' || type === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/is-object.js
// module id = 12
// module chunks = 0